module.exports = __webpack_public_path__ + "static/media/car.dff640e8.svg";